export function toLower(str) {
  return str.toLowerCase();
}

export function toUpper(str) {
  return str.toUpperCase();
}
